import React from 'react';
import { formatValue, trendLabel } from '../format';

/**
 * Model-generated outlook for a single indicator.
 *
 * This replaced a block of hardcoded prose that asserted a fixed forecast for
 * every factor regardless of market conditions. When the prediction service is
 * unconfigured or returns a placeholder, this renders the reason instead of a
 * number - a forecast nobody generated is worse than no forecast.
 */
const RatePrediction = ({ prediction, unavailableReason, valueType = 'percent' }) => {
  if (!prediction) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <div className="text-sm font-medium text-gray-700 mb-1">Outlook unavailable</div>
        <p className="text-sm text-gray-500">
          {unavailableReason || 'No prediction has been generated for this indicator.'}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-baseline flex-wrap gap-x-3 gap-y-1">
        <span className="text-2xl font-bold text-blue-900">
          {formatValue(prediction.value, valueType)}
        </span>
        {prediction.trend && (
          <span className="text-sm font-medium text-blue-800">{trendLabel(prediction.trend)}</span>
        )}
        {prediction.timeframe && (
          <span className="text-xs bg-white text-blue-700 px-2 py-1 rounded shadow-sm">
            {prediction.timeframe}
          </span>
        )}
      </div>

      {prediction.rationale && (
        <p className="text-sm text-blue-900 mt-3 pt-3 border-t border-blue-200">{prediction.rationale}</p>
      )}

      {prediction.model && (
        <p className="text-xs text-blue-600 mt-2">Generated by {prediction.model}</p>
      )}
    </div>
  );
};

export default RatePrediction;
